import { useMemo } from "react";
import useAuth from "./useAuth";
import { KeycloakTokenParsed } from "keycloak-js";

export const useGetAppRoles = (): string[] => {
  const { authenticated, tokenParsed } = useAuth();

  return useMemo(() => {
    if (!authenticated || !tokenParsed) return [];

    const roles =
      (tokenParsed as KeycloakTokenParsed)?.resource_access
        ?.app?.roles ?? [];

    return Array.isArray(roles) ? roles : [];
  }, [authenticated, tokenParsed]);
};
